export const getUniqueValuesSet = (values: string[] | undefined) => {
  if (values) {
    const valuesSet = new Set(values);
    return Array.from(valuesSet);
  }
  return [];
};
